module.exports = "https://r.nearpod.com/assets/media/image/fitb-0ed86a594f2c41c2d371183989cfa4ed.svg";